import classes from "./SolutionList.module.scss";
import Image from '../../../Image/Image';
import grph from "../../../Assets/Img/Src/grph2.png"
import grphWebp from "../../../Assets/Img/Webp/grph2.webp"
import Tooltip from '../../../Tooltip/tooltip';

const SolutionList = () => {
  return (
    <div className={classes.SolutionList}>
      <span className={classes.PinkBlock}></span>
      <div className={classes.Wrapper}>
      <div className={classes.Item}>
        <div className={classes.LeftSide}>
          <h3 className={classes.Title}>В первую очередь надо было определить целевую аудиторию сайта.</h3>
          <p className={classes.Description}>
            Так как Яндекс Метрика не была размечена целями,
            и не была подключена электронная коммерция Яндекса, мы определили ЦА через длительность
            пребывания на сайте.
            </p>
        </div>
        <div className={classes.RightSide}>
          <p className={classes.Answer}>
            <span>Доля женщин в возрасте от 25 до 44 лет составила 80% аудитории</span> и показала наилучшие данные по времени, проведенном на сайте.</p>
          {/* <br/> */}
          <p className={classes.Answer}>Дальнейшие наблюдения на основе статистики электронной коммерции и целей подтвердили данный факт.
              </p>
        </div>
      </div>
      <div className={classes.Item}>
        <div className={classes.LeftSide}>
          <h3 className={classes.Title}>Также мы<br /> выяснили:</h3>
          <p className={classes.Description}>Самая заинтересованная аудитория приходит из Москвы и Московской области, что в принципе было ожидаемо.
            </p>
        </div>
        <div className={classes.RightSide}>
          <p className={classes.Answer}>
            Данные по интересам пользователей показали, что наиболее высокий аффинити-индекс <Tooltip customClassToltip={classes.CustomTooltip} customClass={classes.Tooltip} text={"Параметр, определяющий долгосрочные интересы пользователей"}/>
            мы видим по интересам: Красота и здоровье, Кулинария, Финансы.
            </p>
            <p className={classes.Answer}>
            И что крайне важно
            <span> 85% пользователей посещало сайт с мобильных устройств.</span>
            </p>
            <p className={classes.Answer}>
              Данный факт ранее никто не учитывал.
            </p>
        </div>
      </div>
      <div className={classes.Item}>
        <div className={classes.LeftSide}>
          <h3 className={classes.Title}>Для понимания куда прикладывать основные усилия по каналу SEO:</h3>
          <p className={classes.Description}>
            Нам еще не хватало данных по количеству страниц в индексе поисковых систем и информации о позициях поисковых запросах.
            </p>
        </div>
        <div className={classes.RightSide}>
          <p className={classes.Answer + " " + classes.SmallText}>
            
            Данные системы Яндекс Вебмастер показали, что <span>в поиске находится около 1 700 страниц, и динамики роста практически нет.</span>
          </p>
          <p className={classes.Answer + " " + classes.SmallText}>Похожие данные мы увидели в GoogleSearch Console. Это при том, <span>что сканирование сайта программой выявляло около 5 000 страниц.</span></p>
          <p className={classes.Answer + " " + classes.SmallText}>Если бы на страницах не было ошибок, и оптимизация была бы сделана качественно, то мы бы фиксировали примерно одинаковое количество страниц на сайте и в индексе.</p>
          <p className={classes.Answer + " " + classes.SmallText}>
            <span>В нашем случае лишь 34% страниц сайта было в индексе.</span>
          </p>
        </div>
      </div>
      </div>
      <div className={classes.GraphicWrapper}>
        <div className={classes.Graphic}>
          <Image src={grph} srcWebp={grphWebp} />
        </div>
      </div>
    </div>
  )
}

export default SolutionList;